import { GreyGrey80, Box } from '@sequencehq/core-components'
import { camelCase } from 'lodash/fp'

export const ReadOnlyItem = (props: { label: string; value: string }) => (
  <>
    <Box>{props.label}</Box>
    <Box
      color={GreyGrey80}
      data-testid={`priceEditor.readOnlyDetails.${camelCase(props.label)}`}
    >
      {props.value}
    </Box>
  </>
)
